import { ref } from '@vue/composition-api';

export default function useVideo({ emit }) {
  const video = ref(null);
  const playing = ref(false);

  function play() {
    video.value.play();
    playing.value = true;
    emit('play');
  }

  function pause() {
    video.value.pause();
    playing.value = false;
    emit('pause');
  }

  function preload() {
    video.value.addEventListener('loadeddata', () => {
      video.value.currentTime = 0;
    });
  }

  return {
    video,
    play,
    pause,
    preload,
    playing,
  };
}
